/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unusual_Absence_Detection_Popup_TextInputs */



/**
* | output |
* | --- |
* | "If all thermostatic heads in the room do not detect presence for 1 hour during a comfort time slot, they will switch to pre-comfort until the next presence d..." |
*
* @param {Unusual_Absence_Detection_Popup_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const unusual_absence_detection_popup_text = /** @type {((inputs?: Unusual_Absence_Detection_Popup_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unusual_Absence_Detection_Popup_TextInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("If all thermostatic heads in the room do not detect presence for 1 hour during a comfort time slot, they will switch to pre-comfort until the next presence detection.")
	return /** @type {LocalizedString} */ ("Si toutes les têtes th. de la pièce ne détectent pas de présence pendant 1h sur une plage horaire de confort, alors elles passeront en pré-confort en attendant la prochaine détection de présence.")
});